import { ApiService }           from '../api/api.service';
import { CustomerModel }        from '../customers/models/customer';
import { CustomersService }     from '../customers/customers.service';
import { InvoiceModel }         from './models/invoice';
import { Table }                from '../table/types/table';
import { TableColumn }          from '../table/types/table-column';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }         from '../table/table.service';

export class InvoicesForPaymentCtrl implements ng.IOnInit {
  areAllSelected = false;
  columns        : Array<TableColumn>;
  selectedItems  : Array<InvoiceModel> = [];
  tableCacheKey  = 'branchCustomerInvoices';
  tableSettings  : Table;

  constructor (
    private $translate  : ng.translate.ITranslateService,
    private customer    : CustomerModel,
    private customersApi: CustomersService,
    public invoices     : Array<InvoiceModel>,
    private tableApi    : TableService,
    private workshopAPI : ApiService
  ) {}

  $onInit () : void {
    this.columns = [
      {
        classes: 'text-left',
        field  : 'invoice_number',
        header : {
          text: this.$translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: this.$translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : this.$translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : this.$translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ];

    if ( this.customersApi.isBranchCustomer(this.customer) ) {
      this.columns.splice(1, 0, {
        field : 'store_name',
        header: {
          text: this.$translate.instant('GENERAL_SPACE.FIELD.STORE')
        }
      });
    }

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.$translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false,
      },
      rows: {
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: this.tableApi.setSortingFromCache(this.tableCacheKey, {
        direction: 'desc',
        field    : 'post_date'
      }),
      static: true
    };
  }

  handleInvoiceSelection () : void {
    this.selectedItems = this.invoices.filter(invoice => invoice.selected);

    this.areAllSelected = this.invoices.length === this.selectedItems.length;
  }

  toggleAll () : void {
    this.invoices.forEach(invoice => {
      invoice.selected = !this.areAllSelected;
    });

    this.areAllSelected = !this.areAllSelected;
    this.selectedItems  = this.areAllSelected
      ? this.invoices
      : [];
  }

  getInvoices ( params : TableQueryParameters ) : void {
    this.workshopAPI.get('/customers/invoice_list', [
      this.customer.id,
      0,
      '*',
      'P',
      'I',
      params.field,
      params.direction
    ])
    .then(( invoices : Array<InvoiceModel> ) => {
      this.invoices = invoices;
    });
  }
}
